import React from "react";
import { LOGO, LOGO_BLACK, LOGO_BLUE } from "../../images";
import { getAuth, logout } from "../common/common";

const Header = () => {
  const user = getAuth();
  const handleLogout = () => {
    logout();
  };
  return (
    <div className="page-header">
      <div className="header-wrapper row m-0">
        <div className="header-logo-wrapper col-2 p-0">
          <div className="logo-wrapper">
            <a href="/forms/t0DoMPhK" className="nav-link">
            <img src={LOGO_BLUE} height={25} />
            </a>
          </div>
          <div className="toggle-sidebar">
            <i
              className="status_toggle middle sidebar-toggle"
              data-feather="align-center"
            />
          </div>
        </div>
        <div className="left-header col-4 horizontal-wrapper ps-0">
          <ul className="nav-menus">
            <li className="nav-item">
              <a href="/forms/t0DoMPhK" className="nav-link">
                <span>Forms</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="nav-right col-6 pull-right right-header p-0">
          <ul className="nav-menus">
            <li className="profile-nav onhover-dropdown p-0 me-0">
              <div className="d-flex profile-media">
                <img
                  className="b-r-50"
                  src="../assets/images/dashboard/profile.png"
                  alt=""
                />
                <div className="flex-grow-1">
                  <span>{user?.email}</span>
                  <p onClick={handleLogout} className="mb-0 mt-2 font-roboto">
                    Logout <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
